import BookingMessages from './BookingMessages';

export default BookingMessages;
